import { Injectable } from '@angular/core';
import CustomStore, { ResolvedData } from 'devextreme/data/custom_store';
import { firstValueFrom, ReplaySubject } from 'rxjs';

import { SubscriptionItemEntity } from './subscription-item.entity';
import { SubscriptionListEntity } from './subscription-list.entity';

@Injectable()
export class DxSubscriptionListProvider {
	private dxStore: CustomStore | null = null;

	private readonly data$ = new ReplaySubject<SubscriptionListEntity>(1);

	public updateData(list: SubscriptionListEntity): void {
		this.data$.next(list);
	}

	public createDxStore(): CustomStore {
		if (!this.dxStore) {
			this.dxStore = new CustomStore({
				key: 'id',
				load: async (): Promise<ResolvedData<SubscriptionItemEntity>> => {
					const list = await firstValueFrom(this.data$);
					return Promise.resolve({
						data: list.elements.toList().toArray() || [],
						totalCount: list.totalItems,
					});
				},
			});
		}

		return this.dxStore;
	}
}
